const DEFAULT_OPACITY = 200;
const DEFAULT_FILL_COLOR = 'rgba(114, 180, 95, 1)';
const DEFAULT_STROKE_COLOR = 'rgba(0, 0, 0, 1)';
const TIP_BAR_HEIGHT = 32;
const CURRENT_VERSION = 3;
const DEFAULT_LAYERS = [
    { id: "Tall trees", name: "Tall trees", opacity: 1, visible: true },
    { id: "Trees", name: "Trees", opacity: 1, visible: true },
    { id: "Shrubs", name: "Shrubs", opacity: 1, visible: true },
    { id: "Herbs", name: "Herbs", opacity: 1, visible: true },
    { id: "Ground cover", name: "Ground cover", opacity: 1, visible: true },
    { id: "Roots", name: "Roots", opacity: 1, visible: true },
    { id: "Vines", name: "Vines", opacity: 1, visible: true },
];


export { DEFAULT_OPACITY, DEFAULT_FILL_COLOR, DEFAULT_STROKE_COLOR, TIP_BAR_HEIGHT, CURRENT_VERSION, DEFAULT_LAYERS };
